import { isPlatformBrowser } from "@angular/common";
import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { inject, PLATFORM_ID } from "@angular/core";
import { catchError, throwError } from "rxjs";
import { LoadingBarService } from "@ngx-loading-bar/core";
import { NgxSpinnerService } from "ngx-spinner";
import { getCookie } from "@sportyano/core/common/utils/cookies-controller";
import { AuthService } from "@sportyano/core/services/authServices/auth.service";
import { ToasterMessagesService } from "@sportyano/core/services/toaster-messages/toaster-messages.service";
import { Router } from "@angular/router";

const ERROR_TRANSLATIONS_AR: Record<string, string> = {
	'The member id has already been taken.': 'رقم العضوية مُستخدم بالفعل.',
	'The member id has already been taken': 'رقم العضوية مُستخدم بالفعل.',
	'Failed to update member': 'فشل تحديث بيانات العضو.',
	'The national id has already been taken.': 'الرقم القومي مُسجل مسبقاً.',
	'The phone number has already been taken.': 'رقم الهاتف مُسجل مسبقاً.',
	'The email has already been taken.': 'البريد الإلكتروني مُسجل مسبقاً.',
	'An unexpected error occurred. Please try again later.': 'حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى لاحقاً.',
	'End date must be after start date': 'تاريخ الانتهاء يجب أن يكون بعد تاريخ البدء.',
	'Status must be one of active, expired, or pending': 'الحالة يجب أن تكون نشط أو منتهي أو قيد الانتظار.',
	'Sport does not exist': 'الرياضة غير موجودة.',
	'Country does not exist': 'الدولة غير موجودة.',
	'City does not exist': 'المدينة غير موجودة.',
};

function formatErrorMessage(msg: any): string {
	if (typeof msg !== 'string') return msg;
	const trimmed = msg.trim();
	if (ERROR_TRANSLATIONS_AR[trimmed]) {
		return ERROR_TRANSLATIONS_AR[trimmed];
	}
	if (trimmed.startsWith('Failed to update member:')) {
		return 'فشل تحديث بيانات العضو: ' + trimmed.replace('Failed to update member:', '').trim();
	}
	return msg;
}

export const generalInterceptor: HttpInterceptorFn = (req, next) => {
	const platformId = inject(PLATFORM_ID);
	const authService = inject(AuthService);
	let token: string = getCookie("token") || "";
	let language: string = getCookie("lang") || "ar";
	const loadingBar = inject(LoadingBarService);
	const spinner = inject(NgxSpinnerService);
	const toastr = inject(ToasterMessagesService);
	const router = inject(Router);
	req = req.clone({
		setHeaders: {
			locale: language,
		},
	});
	if (token && !token.startsWith("cafe_token_")) {
		req = req.clone({
			setHeaders: {
				Authorization: `Bearer ${token}`,
			},
		});
	}

	return next(req).pipe(
		catchError((error) => {
			if (req.headers.has('skip-error-toast')) {
				return throwError(() => error);
			}

			if (error instanceof HttpErrorResponse && error.status === 401) {
				return throwError(() => error);
			}

			if (error.error && isPlatformBrowser(platformId)) {
				loadingBar.stop();
				spinner.hide();
				if (error.error.errors) {
					const errorMessages = Object.values(
						error.error.errors
					).flat();
					errorMessages.forEach((errorMessage: any) => {
						toastr.showError(formatErrorMessage(errorMessage));
					});
				} else if (error?.error?.message) {
					toastr.showError(formatErrorMessage(error.error.message));
				} else if (error.error) {
					toastr.showError(formatErrorMessage(error.error.error));
				} else {
					toastr.showError(
						"حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى لاحقاً."
					);
				}
			}
			return throwError("");
		})
	);
};
